// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auto-filled-requests__container {
  margin: 0 -0.5rem;
  padding: 0 0.7rem;
  border-top: var(--main-border-width) solid var(--main-border-color);
}
.auto-filled-requests__container .organization-name {
  font-weight: bolder;
  text-shadow: 0px 0px 0px #000;
}
.auto-filled-requests__container .auto-filled-requests__row {
  display: grid;
  grid-template-columns: 1fr auto;
  margin: 0.5rem 0;
  align-content: baseline;
  line-height: normal;
}
.auto-filled-requests__container .auto-filled-requests__programs {
  margin-left: 2rem;
}
.auto-filled-requests__container .auto-filled-requests__icon {
  width: 1rem;
  margin-right: 0.3rem;
  text-align: center;
}
.auto-filled-requests__container .badge-count {
  margin-left: 0.2rem;
  margin-top: -3px;
  font-style: normal;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/RequestCard/components/AutoFilledRequests.less"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,iBAAA;EACA,mEAAA;AACF;AAJA;EAMI,mBAAA;EACA,6BAAA;AACJ;AARA;EAWI,aAAA;EACA,+BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;AAfA;EAmBI,iBAAA;AADJ;AAlBA;EAuBI,WAAA;EACA,oBAAA;EACA,kBAAA;AAFJ;AAvBA;EA6BI,mBAAA;EACA,gBAAA;EACA,kBAAA;AAHJ","sourcesContent":[".auto-filled-requests__container {\n  margin: 0 -.5rem;\n  padding: 0 .7rem;\n  border-top: var(--main-border-width) solid var(--main-border-color);\n\n  .organization-name {\n    font-weight: bolder;\n    text-shadow: 0px 0px 0px #000;\n  }\n\n  .auto-filled-requests__row {\n    display: grid;\n    grid-template-columns: 1fr auto;\n    margin: 0.5rem 0;\n    align-content: baseline;\n    line-height: normal;\n  }\n\n  .auto-filled-requests__programs {\n    margin-left: 2rem;\n  }\n\n  .auto-filled-requests__icon {\n    width: 1rem;\n    margin-right: .3rem;\n    text-align: center;\n  }\n\n  .badge-count {\n    margin-left: .2rem;\n    margin-top: -3px;\n    font-style: normal;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
